/**
 * US States Data for Address Standardization
 * PCI DSS Level 1 Compliant - Optimized for AVS accuracy
 * 
 * Uses 2-letter postal codes for best Address Verification Service results
 * Sorted alphabetically for better UX in dropdowns
 */

const US_STATES = [
  { code: 'AL', name: 'Alabama' },
  { code: 'AK', name: 'Alaska' },
  { code: 'AZ', name: 'Arizona' },
  { code: 'AR', name: 'Arkansas' },
  { code: 'CA', name: 'California' },
  { code: 'CO', name: 'Colorado' },
  { code: 'CT', name: 'Connecticut' },
  { code: 'DE', name: 'Delaware' },
  { code: 'DC', name: 'District of Columbia' },
  { code: 'FL', name: 'Florida' },
  { code: 'GA', name: 'Georgia' },
  { code: 'HI', name: 'Hawaii' },
  { code: 'ID', name: 'Idaho' },
  { code: 'IL', name: 'Illinois' },
  { code: 'IN', name: 'Indiana' },
  { code: 'IA', name: 'Iowa' },
  { code: 'KS', name: 'Kansas' },
  { code: 'KY', name: 'Kentucky' },
  { code: 'LA', name: 'Louisiana' },
  { code: 'ME', name: 'Maine' },
  { code: 'MD', name: 'Maryland' },
  { code: 'MA', name: 'Massachusetts' },
  { code: 'MI', name: 'Michigan' },
  { code: 'MN', name: 'Minnesota' },
  { code: 'MS', name: 'Mississippi' },
  { code: 'MO', name: 'Missouri' },
  { code: 'MT', name: 'Montana' },
  { code: 'NE', name: 'Nebraska' },
  { code: 'NV', name: 'Nevada' },
  { code: 'NH', name: 'New Hampshire' },
  { code: 'NJ', name: 'New Jersey' },
  { code: 'NM', name: 'New Mexico' },
  { code: 'NY', name: 'New York' },
  { code: 'NC', name: 'North Carolina' },
  { code: 'ND', name: 'North Dakota' },
  { code: 'OH', name: 'Ohio' },
  { code: 'OK', name: 'Oklahoma' },
  { code: 'OR', name: 'Oregon' },
  { code: 'PA', name: 'Pennsylvania' },
  { code: 'RI', name: 'Rhode Island' },
  { code: 'SC', name: 'South Carolina' },
  { code: 'SD', name: 'South Dakota' },
  { code: 'TN', name: 'Tennessee' },
  { code: 'TX', name: 'Texas' },
  { code: 'UT', name: 'Utah' },
  { code: 'VT', name: 'Vermont' },
  { code: 'VA', name: 'Virginia' },
  { code: 'WA', name: 'Washington' },
  { code: 'WV', name: 'West Virginia' },
  { code: 'WI', name: 'Wisconsin' },
  { code: 'WY', name: 'Wyoming' }
];

/**
 * Get state code from state name
 * Handles common variations and misspellings
 * @param {string} stateName - State name or code
 * @returns {string|null} Two-letter state code or null if not found
 */
function getStateCode(stateName) {
  if (!stateName) return null;
  
  const normalized = stateName.toUpperCase().trim();
  
  // Already a valid state code
  const stateByCode = US_STATES.find(state => state.code === normalized);
  if (stateByCode) return stateByCode.code;
  
  // Try to match by name
  const stateByName = US_STATES.find(state => 
    state.name.toUpperCase() === normalized
  );
  if (stateByName) return stateByName.code;
  
  // Handle common variations
  const variations = {
    'DISTRICT OF COLUMBIA': 'DC',
    'D.C.': 'DC',
    'WASHINGTON DC': 'DC',
    'WASHINGTON D.C.': 'DC'
  };
  
  if (variations[normalized]) {
    return variations[normalized];
  }
  
  return null;
}

/**
 * Validate if state code is valid
 * @param {string} stateCode - Two-letter state code
 * @returns {boolean} True if valid state code
 */
function isValidStateCode(stateCode) {
  if (!stateCode) return false;
  return US_STATES.some(state => state.code === stateCode.toUpperCase());
}

export {
  US_STATES,
  getStateCode,
  isValidStateCode
};